import { listAllAutocompleteProperties, listAllAutocompletePropertiesNext } from '../thunks/autocomplete-properties';
import { handlePending, handleRejected } from './utils';

export const autocompletePropertiesReducers = (builder) => {
  // List all properties
  builder
    .addCase(listAllAutocompleteProperties.fulfilled, (state, action) => {
      const files = action.payload?.data || [];
      const offset = action.payload?.offset || 0;
      state.autocompleteProperties.value = files;
      state.autocompleteProperties.offset = offset;
      state.autocompleteProperties.hasMore = files.length > 0;
      state.autocompleteProperties.loading = false;
    })
    .addCase(listAllAutocompleteProperties.pending, (state) => handlePending(state, 'autocompleteProperties'))
    .addCase(listAllAutocompleteProperties.rejected, (state) => handleRejected(state, 'autocompleteProperties'));

  // List all properties next
  builder
    .addCase(listAllAutocompletePropertiesNext.fulfilled, (state, action) => {
      const files = action.payload?.data || [];
      const offset = action.payload?.offset || 0;
      state.autocompleteProperties.value = [...state.autocompleteProperties.value, ...files];
      state.autocompleteProperties.offset = offset;
      state.autocompleteProperties.hasMore = files.length > 0;
      state.autocompleteProperties.loading = false;
    })
    .addCase(listAllAutocompletePropertiesNext.pending, (state) => handlePending(state, 'autocompleteProperties'))
    .addCase(listAllAutocompletePropertiesNext.rejected, (state) => handleRejected(state, 'autocompleteProperties'));
};
